export const MAP_OPTIONS = {
  center: {lat: 44, lng: -40},
  fullscreenControl: false,
  mapTypeControl: false,
  maxZoom: 14,
  minZoom: 1,
  restriction: {
    latLngBounds: {
      north: 84,
      south: -64,
      west: -179.99,
      east: 179.99,
    },
    strictBounds: true,
  },
  streetViewControl: false,
  styles: [
    {
      featureType: 'administrative',
      elementType: 'geometry',
      stylers: [{visibility: 'off'}],
    },
    {
      featureType: 'administrative.country',
      elementType: 'geometry.stroke',
      stylers: [{visibility: 'on'}, {weight: 1}],
    },
    {
      featureType: 'administrative.country',
      elementType: 'labels.text.fill',
      stylers: [{color: '#4d4d4d'}],
    },
    {
      featureType: 'administrative.land_parcel',
      stylers: [{visibility: 'off'}],
    },
    {
      featureType: 'administrative.neighborhood',
      stylers: [{visibility: 'off'}],
    },
    {
      featureType: 'administrative.province',
      elementType: 'geometry.stroke',
      stylers: [{color: '#4d4d4d'}, {visibility: 'on'}],
    },
    {
      featureType: 'landscape',
      stylers: [{visibility: 'off'}],
    },
    {
      featureType: 'poi',
      stylers: [{visibility: 'off'}],
    },
    {
      featureType: 'poi',
      elementType: 'labels.text',
      stylers: [{visibility: 'off'}],
    },
    {
      featureType: 'road',
      stylers: [{visibility: 'off'}],
    },
    {
      featureType: 'road',
      elementType: 'labels',
      stylers: [{visibility: 'off'}],
    },
    {
      featureType: 'road',
      elementType: 'labels.icon',
      stylers: [{visibility: 'off'}],
    },
    {
      featureType: 'transit',
      stylers: [{visibility: 'off'}],
    },
    {
      featureType: 'water',
      stylers: [{visibility: 'simplified'}, {weight: 1.5}],
    },
    {
      featureType: 'water',
      elementType: 'geometry.fill',
      stylers: [{color: '#4679b9'}],
    },
    {
      featureType: 'water',
      elementType: 'labels',
      stylers: [{color: '#4d4d4d'}, {visibility: 'on'}],
    },
    {
      featureType: 'water',
      elementType: 'labels.text',
      stylers: [{color: '#4d4d4d'}, {visibility: 'off'}],
    },
    {
      featureType: 'water',
      elementType: 'labels.text.fill',
      stylers: [{color: '#f5f5f5'}, {visibility: 'on'}],
    },
  ],
  zoom: 1.5,
};
